import { useEffect } from 'react';

import { useAuthentication } from '@givebacks/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { ButtonMantine, Center, Stack, Title } from 'ui';
import { LogoGivebacksBlue } from 'ui/Icons';

import { PagesUrl } from '../../utils';
import { PasswordResetForm } from './PasswordResetForm';

export const PasswordReset = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logOut } = useAuthentication();
  const queryParams = useLocation().search;
  const resetPasswordToken = new URLSearchParams(queryParams).get('reset_password_token');

  // logout user if logged in, need new user auth-token after reset password
  useEffect(() => {
    if (isAuthenticated) {
      logOut();
    }
  }, []);

  return (
    <Center mt="xl">
      <Stack>
        <Center my="xl">
          <LogoGivebacksBlue />
        </Center>
        <Title order={1}>Reset Password</Title>
        <PasswordResetForm reset_passwordToken={resetPasswordToken} />
        <ButtonMantine
          variant="subtle"
          onClick={() => {
            navigate(PagesUrl.HOME);
          }}
        >
          Back to Sign In
        </ButtonMantine>
      </Stack>
    </Center>
  );
};
